import i from "react";
import { useTheme as d, Divider as c } from "@chakra-ui/react";
const a = ({ borderColor: e, ...r }) => {
  const { borderStyle: o } = d(), { color: t } = o.default;
  return /* @__PURE__ */ i.createElement(c, { borderColor: e || t, ...r });
};
export {
  a as Divider
};
